module.exports = __webpack_public_path__ + "static/media/dotitle.83201b9e.png";